import { COURSE } from './course.data.js';
export { COURSE };
export function isLesson(day) {
    return day.type !== 'rest';
}
export function isRest(day) {
    return day.type === 'rest';
}
/**
 * Шаги курса — только дни с занятием. Выходные показываем как подсказку
 * «можно отдохнуть», но прогресс по ним не считаем: курс идёт по факту
 * выполнения, а не по календарю, и пропущенный выходной ничего не ломает.
 */
export const STEPS = COURSE.days.filter(isLesson);
export const TOTAL_STEPS = STEPS.length;
export function dayByNumber(day) {
    return COURSE.days.find((d) => d.day === day);
}
export function lessonByNumber(day) {
    return STEPS.find((d) => d.day === day);
}
/** Ближайшее непройденное занятие или null, если пройдено всё. */
export function nextLesson(done) {
    const set = new Set(done);
    return STEPS.find((d) => !set.has(d.day)) ?? null;
}
/** Порядковый номер занятия в курсе (1..TOTAL_STEPS), а не номер дня календаря. */
export function stepIndex(day) {
    return STEPS.findIndex((d) => d.day === day) + 1;
}
/**
 * Выходные, идущие сразу за указанным днём. Нужны, чтобы после отметки
 * «выполнено» сказать, что дальше по плану пауза, — иначе ребёнок пройдёт
 * весь курс за два вечера и ничего не успеет закрепиться.
 */
export function restAfter(day) {
    const idx = COURSE.days.findIndex((d) => d.day === day);
    if (idx < 0)
        return [];
    const out = [];
    for (let i = idx + 1; i < COURSE.days.length; i++) {
        const d = COURSE.days[i];
        if (!isRest(d))
            break;
        out.push(d);
    }
    return out;
}
export const WEEK_TITLES = {
    1: 'Первые звуки',
    2: 'Первые аккорды',
    3: 'Три аккорда и первая песня',
    4: 'Ритм, риффы, репертуар',
    5: 'Финал',
};
export function daysOfWeek(week) {
    return COURSE.days.filter((d) => d.week === week);
}
export const WEEKS = [...new Set(COURSE.days.map((d) => d.week))].sort((a, b) => a - b);
//# sourceMappingURL=course.js.map